
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-competition",
      function () {
        return require("private-next-pages/ai-competition/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-competition"])
      });
    }
  